import React from 'react';
import { useContext } from 'react';
import { px2rem } from '@bedrock/utils';

function PureText(props: {
  value?: any;
  rowKey?: any;
  column?: any;
  row?: any;
  rowIndex?: number;
  dataStore?: any;
  dataIndex?: any;
  toggleEditableRowKey?: any;
  getRowKey?: any;
  readonlyFormat?: any;
}) {
  const {
    value,
    rowIndex,
    rowKey,
    dataStore,
    column,
    dataIndex,
    row,
    readonlyFormat,
    ...rest
  } = props;
  const { viewBase = 1 } = useContext(px2rem);
  if (column?.render) {
    return <>{column.render(value, row, rowIndex)}</>;
  }
  return (
    <div style={{ padding: value ? `${10 * viewBase}px 0` : 0 }}>
      {typeof readonlyFormat === 'function'
        ? readonlyFormat(row, dataStore)
        : row?.[dataIndex] || value}
    </div>
  );
}

export default PureText;
